<template>

    <div class="browser-bar">
        <div class="browser-bar-dots" aria-hidden="true">
            <span /><span /><span />
        </div>
        <a v-if="url" class="browser-bar-url" :href="url" target="_blank" rel="noopener noreferrer">
            <i class="fas fa-lock" aria-hidden="true" />
            <span>{{ url }}</span>
        </a>
    </div>

</template>

<style scoped lang="scss">

    .browser-bar {
        @include light-theme;
        align-items: center;
        background: $color-bg;
        border-bottom: 1px solid $color-rule;
        display: flex;
        flex-shrink: 0;
        gap: 10px;
        min-height: 42px;
        padding: 8px 14px;
        user-select: none;
    }

    .browser-bar-dots {
        display: flex;
        flex-shrink: 0;
        gap: 6px;
        span {
            border-radius: 50%;
            display: block;
            height: 8px;
            width: 8px;
            &:nth-child(1) { background: $color-danger; }
            &:nth-child(2) { background: $color-gold; }
            &:nth-child(3) { background: $color-success; }
        }
    }

    .browser-bar-url {
        @include font-regular(11px);
        align-items: center;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 999px;
        color: $color-text;
        cursor: pointer;
        display: flex;
        flex: 1 1 auto;
        gap: 6px;
        min-width: 0;
        padding: 5px 10px;
        text-decoration: none;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }
        i {
            color: $color-success;
            flex-shrink: 0;
            font-size: 9px;
        }
        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

</style>

<script>

export default {

    props: {
        url: {
            type: String,
            default: '',
        },
    },

}

</script>
